<template>
    <!-- 听书精选组合 -->
    <div class="main paddingH16 white_bg">
        <div class="margin-box">
            <div class="recent-changes">
                <!-- 标题 -->
                <div class="title">
                      <div class="title-link clearfix">
                          <h3 class="bold">精选组合</h3>
                          <div class="link-right" style="margin-top: 22px">
                              <router-link to="/learn/listenComp/choicenssMore">
                                <span>更多</span>
                                <img src="icon/learnIcon/more.svg" alt="更多图标">
                              </router-link>
                          </div>
                      </div>
                      <div class="cho-explain">
                          星级专题包课程，精准提升早教技能
                      </div>
                </div>
                <!-- 精选内容 -->
                <div class="content">
                    <ul>
                        <li class="choiceness-model" v-for="(item , index) in dataList" :key="index" @click="toDetail(item.id)">
                            <div class=" choiceness-img">
                            <img class=" cover item-img" :src="item.coverImg" alt="精选图片">
                            <div class="choiceness-title">
                                <img style="margin-left:6px;width:7px;height:9px;vertical-align: sub;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAAxUlEQVQ4T52Sy01CQRhGzylAFzRBQujFHnhUIIk7hCpYSBUuSdQGbMFIhI2JLngsSYb8iZjJDVznOsuZc77JzP/JP5bhpJTawEF9K8kwpTQGpj/wAhioqzo5pG+glUFb4FadXxJDShcOn4Ch+l49r5OC3QN3wEz9Df9LOl3yAvTUZWyUSsF+Al31q4kU4o362ETaAR11XSo9A/3SNzX+vWhHzOnj3Jw2wHWlESP1oa4RE+A+697Z9Dwgb/mV+lrU8hKoyhwBBB1YEg4P/RwAAAAASUVORK5CYII=" alt="精选播放图标">
                                <span class="IitenIn">{{item.playCount||0}}人收听</span>

                            </div>
                            </div>
                            <h3>{{item.title}}</h3>
                            <!-- <div class="introduce">
                                {{item.introduce}}
                            </div> -->
                            <div class="parameter">
                                <span class="update">已更新{{item.segCount || 0}}本</span>
                            </div>

                        </li>

                        <!-- <li class="choiceness-model" v-for="i in 6"  >
                                <div class=" choiceness-img">
                                <img class=" cover item-img" :src="item.coverImg" alt="精选图片">
                                <img style="width:100%;" src="data:image/jpeg;base64,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" alt="">
                               <img src="data:image/jpeg;base64,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" alt="">
                                <div class="choiceness-title">
                                    <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="精选播放图标">
                                    <span class="IitenIn">120人收听</span>

                                </div>
                                </div>
                                <h3>地点方法对付</h3>
                                <div class="parameter">
                                    <span class="update">更新2本</span>
                                </div>

                         </li> -->
                    </ul>
                </div>

            </div>
        </div>

    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';


const config = {
    apiConfig : {
        list : {
            url : 'portal/api/audio',
            // totalPagePath : 'data.pages',
            params:{
                // limit:4,
                type:4
            },
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages'
        }
    }
};



export default {
    name: "choicenessAudioModule",
    extends : shixunPagePart,

    data(){
        return {
            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            pageSize : 6,
        }
    },
     components: {
    },


    methods:{
        toDetail(id){
            this.$router.push({name:'albumID',params: {id:id}})
        }
    },
    mounted(){
    }
}
</script>
<style scoped lang="scss">

    //div,ul,li,input,h1,h2,h3,h4,h5,h6 {
    //    margin: 0;
    //    padding: 0;
    //}

    //.margin-box{
    //    background: #fff;
    //}

    .recent-changes{
        width: 100%;
        box-sizing: border-box;
        //padding: 0 18px 20px;
        padding: 0 0 20px;
    }

    // 标题样式
    .title{
        .title-link{
            h3{
                float: left;
                font-size: 18px;
                color: #34353C;
            }

            .link-right{
                float: right;
                span{
                    width: 24px;
                    height: 17px;
                    font-size: 12px;

                    font-weight: 400;
                    line-height: 17px;
                    color: #999999;

                }
                img{
                    width: 8px;
                    height: 8px;
                }

            }
        }
        .cho-explain{
            width: 100%;
            height: 17px;

            font-size: 13px;

            font-weight: 400;
            // line-height: 23px;
            color: #717380;
            opacity: 0.8;
            margin-top: 8px;
        }
    }

    //精选组样式
    .content{
        ul{
            width: 100%;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: space-between;

            .choiceness-model:nth-child(2){
                margin: 0 15px;
            }
             .choiceness-model:nth-child(5){
                margin: 0 15px;
            }

            .choiceness-model{

                // width: 102px;
                width: calc((100% - 34px) / 3);
                float: left;
                list-style: none;
                padding-top: 24px;
                // margin-left: 15px;
                // margin-right: 7px;

                .choiceness-img{
                    width: 100%;
                    // height: 102px;
                    height: 27.2vw;
                    overflow: hidden;
                    position: relative;
                    border-radius: 6px;
                    .item-img{
                        width: 100%;
                        height: 100%;
                        border-radius: 6px;
                    }



                    .choiceness-title{
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        // width: 102px;
                        width: 100%;
                        height: 25px;
                        line-height: 25px;
                        // background: linear-gradient(180deg, rgba(44, 44, 44, 0) 0%, #000000 100%);
                        background: linear-gradient(180deg, rgba(44, 44, 44, 0) 0%, #000000 100%);
                        opacity: 0.69;
                        border-radius: 0px 0px 6px 6px;
                        .IitenIn{
                        // display: block;

                        font-size: 10px;

                        font-weight: 400;
                        // line-height: 18px;
                        color: #FFFFFF;

                        margin-left: 6px;
                    }

                        .play-icon{
                        // position: absolute;
                        // bottom: 8px;
                        // right: 8px;
                        // width: 26px;
                        // height: 26px;
                        width: 15px;
                        height: 15px;
                        padding-top: 6px;
                    }
                    }

                }
                h3{
                    height: 22px;

                    font-size: 14px;

                    color: #333333;

                    margin-bottom: 2px;
                    margin-top: 4px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .introduce{
                    width: 100%;
                    font-size: 12px;
                    font-weight: 400;
                    color: #7A7A7A;

                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-bottom: 4px;

                }
                .parameter{
                    font-size: 10px;

                    font-weight: 400;
                    color: #999999;

                    // .IitenIn{
                    //     // display: block;
                    //     margin-right: 18px;
                    // }
                    .update{
                        // display: block;

                    }
                }

            }
        }
    }

</style>
